import { FormActions } from './FormActions';

interface SmartFormActionsProps {
  mode: 'create' | 'edit';
  isDirty: boolean;
  isValid: boolean;
  isSubmitting: boolean;
  onCancel: () => void;
  submitLabel?: string;
  cancelLabel?: string;
  className?: string;
}

export function SmartFormActions({
  mode,
  isDirty,
  isValid,
  isSubmitting,
  onCancel,
  submitLabel,
  cancelLabel,
  className,
}: SmartFormActionsProps) {
  // In create mode: enable when all required fields are valid
  // In edit mode: enable when form is dirty AND valid
  const submitDisabled = mode === 'create' ? !isValid : !isDirty || !isValid;

  // Determine the default label based on mode
  const defaultLabel = mode === 'create' ? 'Create' : 'Save Changes';

  return (
    <FormActions
      onCancel={onCancel}
      isSubmitting={isSubmitting}
      submitDisabled={submitDisabled}
      submitLabel={submitLabel || defaultLabel}
      cancelLabel={cancelLabel}
      className={className}
    />
  );
}
